import React from "react";
import { Box, Link, Typography } from "@mui/material";

export default function KeyActionsList({ actions = [] }) {
  if (!actions.length) {
    return (
      <Typography variant="body2" sx={{ color: "#7b8799" }}>
        No habits were completed this week yet.
      </Typography>
    );
  }

  return (
    <Box>
      <Box sx={{ display: "grid", gap: 1 }}>
        {actions.map((action, index) => (
          <Box
            key={`${action.title}-${index}`}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
              py: 1,
              borderBottom: index === actions.length - 1 ? "none" : "1px solid #edf2f7",
            }}
          >
            <Typography variant="body1" sx={{ color: "#15243b", fontWeight: 600 }}>
              {action.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "#7b8799" }}>
              {action.count} {action.count === 1 ? "time" : "times"}
            </Typography>
          </Box>
        ))}
      </Box>
      <Link href="/plan" underline="hover" sx={{ display: "inline-block", mt: 1.1, color: "#4f5df5", fontWeight: 600 }}>
        View all habits
      </Link>
    </Box>
  );
}
